import Vue from 'vue';
import InstantSearch from 'vue-instantsearch';
import bugsnag from 'bugsnag-js';
import bugsnagVue from 'bugsnag-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight, faAngleDown, faPhone, faGlobe, faSearch, faUser, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import * as VueGoogleMaps from 'vue2-google-maps';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/scss/app.scss';

// Set up BugSnag
const bugsnagClient = bugsnag('5b704496651c9293d8808162f695b938');
bugsnagClient.use(bugsnagVue(Vue));

// Set up FontAwesome
library.add(
  faChevronRight, faAngleDown, faPhone, faGlobe,
  faSearch, faFacebookF, faTwitter, faUser, faEnvelope,
);
Vue.component('fa', FontAwesomeIcon);
Vue.component('fa-layers', FontAwesomeLayers);

// Set up Algolia
Vue.use(InstantSearch);

// Set up Google Maps
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCSKeLrRg2efLdjyRCaDvhXr_2v9C3TTP4',
    libraries: 'places',
  },
});

// Router middleware that handles the changing of the document title and meta description.
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  to.meta.metaTags.map((tagDef) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => tag.setAttribute(key, tagDef[key]));

    return tag;
  }).forEach(tag => document.head.appendChild(tag));

  return next();
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
